
<v-dialog
  :value="value"
  max-width="440px"
  :retain-focus="false"
  :persistent="isSubmitting"
  @input="handleDialogInput"
>
  <v-card
    data-testid="password-change-dialog"
    style="border-radius: 16px; padding: 22px 28px 24px"
  >
    <div
      class="d-flex align-center justify-space-between"
      style="margin-bottom: 20px"
    >
      <div style="font-size: 18px; font-weight: 600; line-height: 24px; color: #0D0E17">
        비밀번호 변경
      </div>
      <div
        data-testid="password-change-close-btn"
        class="default-icon-btn d-flex align-center justify-center"
        :aria-disabled="isSubmitting"
        style="width: 32px; height: 32px"
        @click="close"
      >
        <v-icon style="font-size: 20px; color: #8A8DA8">
          mdi-close
        </v-icon>
      </div>
    </div>

    <div
      v-if="errors.form"
      data-testid="password-change-form-error"
      class="password-change-form-error"
    >
      {{ errors.form }}
    </div>

    <div class="password-change-field">
      <label
        for="password-change-current-input"
        data-testid="password-change-current-label"
        class="password-change-label"
      >
        현재 비밀번호
      </label>
      <div
        class="password-change-input-wrap"
        :class="{ 'password-change-input-error': errors.currentPassword }"
      >
        <input
          id="password-change-current-input"
          v-model="form.currentPassword"
          data-testid="password-change-current-input"
          :type="showCurrentPassword ? 'text' : 'password'"
          autocomplete="current-password"
          maxlength="128"
          spellcheck="false"
          :aria-invalid="Boolean(errors.currentPassword)"
          placeholder="현재 비밀번호를 입력해 주세요."
          @input="clearFieldError('currentPassword')"
          @keyup.enter="submit"
        >
        <div
          class="default-icon-btn d-flex align-center justify-center password-visibility-btn"
          @mousedown.prevent
          @click="showCurrentPassword = !showCurrentPassword"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8">
            {{ showCurrentPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}
          </v-icon>
        </div>
      </div>
      <div
        v-if="errors.currentPassword"
        data-testid="password-change-current-error"
        class="password-change-error"
      >
        {{ errors.currentPassword }}
      </div>
    </div>

    <div class="password-change-field">
      <label
        for="password-change-new-input"
        data-testid="password-change-new-label"
        class="password-change-label"
      >
        새 비밀번호
      </label>
      <div
        class="password-change-input-wrap"
        :class="{ 'password-change-input-error': errors.newPassword }"
      >
        <input
          id="password-change-new-input"
          v-model="form.newPassword"
          data-testid="password-change-new-input"
          :type="showNewPassword ? 'text' : 'password'"
          autocomplete="new-password"
          maxlength="64"
          spellcheck="false"
          :aria-invalid="Boolean(errors.newPassword)"
          placeholder="새 비밀번호를 입력해 주세요."
          @input="clearFieldError('newPassword')"
          @keyup.enter="submit"
        >
        <div
          class="default-icon-btn d-flex align-center justify-center password-visibility-btn"
          @mousedown.prevent
          @click="showNewPassword = !showNewPassword"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8">
            {{ showNewPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}
          </v-icon>
        </div>
      </div>
      <div
        v-if="errors.newPassword"
        data-testid="password-change-new-error"
        class="password-change-error"
      >
        {{ errors.newPassword }}
      </div>
    </div>

    <div class="password-change-policy-message">
      {{ passwordRequirementsMessage }}
    </div>

    <div class="password-change-field" style="margin-bottom: 24px">
      <label
        for="password-change-confirm-input"
        data-testid="password-change-confirm-label"
        class="password-change-label"
      >
        새 비밀번호 확인
      </label>
      <div
        class="password-change-input-wrap"
        :class="{ 'password-change-input-error': errors.newPasswordConfirm }"
      >
        <input
          id="password-change-confirm-input"
          v-model="form.newPasswordConfirm"
          data-testid="password-change-confirm-input"
          :type="showNewPasswordConfirm ? 'text' : 'password'"
          autocomplete="new-password"
          maxlength="64"
          spellcheck="false"
          :aria-invalid="Boolean(errors.newPasswordConfirm)"
          placeholder="새 비밀번호를 한 번 더 입력해 주세요."
          @input="clearFieldError('newPasswordConfirm')"
          @keyup.enter="submit"
        >
        <div
          class="default-icon-btn d-flex align-center justify-center password-visibility-btn"
          @mousedown.prevent
          @click="showNewPasswordConfirm = !showNewPasswordConfirm"
        >
          <v-icon style="font-size: 20px; color: #8A8DA8">
            {{ showNewPasswordConfirm ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}
          </v-icon>
        </div>
      </div>
      <div
        v-if="errors.newPasswordConfirm"
        data-testid="password-change-confirm-error"
        class="password-change-error"
      >
        {{ errors.newPasswordConfirm }}
      </div>
    </div>

    <div
      data-testid="password-change-submit-btn"
      class="default-theme-btn d-flex align-center justify-center"
      :class="{ 'disabled-theme-btn': isSubmitting }"
      :aria-disabled="isSubmitting"
      style="width: 100%; height: 40px"
      @click="submit"
    >
      <span style="font-size: 14px; font-weight: 600; line-height: 18px">
        {{ isSubmitting ? '변경 중' : '비밀번호 변경' }}
      </span>
    </div>
  </v-card>
</v-dialog>
